export default "__VITE_ASSET__5b1d4fba__"